import { render, staticRenderFns } from "./PostStudent.vue?vue&type=template&id=76d41839&"
import script from "./PostStudent.vue?vue&type=script&lang=js&"
export * from "./PostStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports